<template>
  <div id="navmenu">
    <div class="header">
      <div class="left" @click="toOne">
        <img src="@/assets/logo.png" alt="" />
      </div>
      <el-menu
        router
        :default-active="$route.path"
        class="el-menu-demo"
        mode="horizontal"
      >
        <el-menu-item index="/" @click="scrollToTop">Borrowing</el-menu-item>
        <el-menu-item index="/companyProfile" @click="scrollToTop"
          >Company Profile</el-menu-item
        >
        <el-menu-item index="/serviceTab" @click="scrollToTop"
          >Service</el-menu-item
        >
      </el-menu>
    </div>
  </div>
</template>

<script>
export default {
  name: 'navmenu',
  data () {
    return {}
  },
  created () {},
  methods: {
    toOne () {
      if (this.$route.path !== '/') {
        this.scrollToTop()
        this.$router.push('/')
      }
    },
    scrollToTop () {
      window.scrollTo(0, 0)
    }
  }
}
</script>

<style scoped lang="scss">
#navmenu {
  font-size: 14px;
  width: 100%;
  position: fixed;
  top: 0;
  left: 0;
  background-color: #fff;
  z-index: 999;
  .header {
    display: flex;
    align-items: center;
    height: 100px;
    width: 1240px;
    margin: auto;
    .left {
      cursor: pointer;
      margin-left: 80px;
      margin-right: 140px;
      img {
        height: 59px;
        width: 256px;
      }
    }
  }
  .el-menu.el-menu--horizontal {
    border-bottom: 0 solid #ffffff;
  }
  .el-menu--horizontal > .el-menu-item.is-active {
    border-bottom: 0 solid #ffffff !important;
    color: #5931F4;
  }
  .el-menu--horizontal > .el-menu-item {
    color: #000;
  }
  .el-menu-item {
    margin-right: 100px;
  }
}
</style>
